import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";

import { EditInput } from "@fidget/common/components/form/editInput";
import { VerticalSeparator } from "../../settingsForms/separators/verticalSeparator/verticalSeparator";

import settingStyles from "../../../../styles/settings.css";
import styles from "../styles.css";

import { staticConfig } from "@fidget/common/config/static-config";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useAgentEditStatus } from "../editStatus/useEditStatus";
import { ElementForm } from "../../settingsForms/elementForm/elementForm/elementForm";
import { ElementFormActions } from "../../settingsForms/elementForm/actions/elementFormActions";
import { ElementFormSaveDiscardIcon } from "../../settingsForms/elementForm/icons/elementFormSaveDiscardIcon";
import { FieldState } from "formstate";

export const NewItemForm = observer(() => {
  const { settings } = useAgentEditStatus();
  const newItem = settings.newItem?.$;

  if (!newItem) {
    return <></>;
  }

  const { reason, reasonSlug } = newItem;

  const renderEditInput = (field: FieldState<string>) => (
    <EditInput
      placeholder={intl.formatMessage("settings.adviserStatuses.form.placeholder")}
      className={classNames(styles["form-input"])}
      autoFocus
      value={field.$}
      onChange={(event) => field.reset((event.target as HTMLInputElement).value)}
      hasError={field.hasError}
      errorHint={field.error}
    />
  );

  return (
    <ElementForm isEdited>
      <div className={classNames(styles["form-element"])}>
        <span className={classNames(settingStyles["form-label-font"])}>
          {intl.formatMessage("settings.adviserStatuses.form.reasonSlug.label")}
        </span>
        {renderEditInput(reasonSlug)}
        <span className={classNames(settingStyles["form-description-font"])}>
          {intl.formatMessage("settings.adviserStatuses.form.reasonSlug.description", {
            maxCharacters: staticConfig.statusSlugMaxCharacters
          })}
        </span>
      </div>
      <VerticalSeparator />
      <div className={classNames(styles["form-element"])}>
        <span className={classNames(settingStyles["form-label-font"])}>
          {intl.formatMessage("settings.adviserStatuses.form.reason.label")}
        </span>
        {renderEditInput(reason)}
      </div>
      <VerticalSeparator />
      <ElementFormActions>
        <ElementFormSaveDiscardIcon
          onSave={settings.saveNewItem}
          onDiscard={settings.discardNewItem}
        />
      </ElementFormActions>
    </ElementForm>
  );
});
